export default __webpack_public_path__ + "static/media/bannerFoxton.191047e4.svg";